export const commonFields = {
    leakFlowNotice: null,
    volumeNotice: null,
    dateOfNextVisit: null,
    dateOfVisit: null,
    timeToVisit: null,
    teamControl: null,
    contact: null,
    work1_accessibilityProblem: null,
    work1_commentAccessibilityProblem: null,
    work1_operationProblem: null,
    work1_commentOperationProblem: null,
    work1_trapdoor: null,
    work1_numberTrapdoor: null,
    work1_stateOfTrapdoor: null,
    work1_stick: null,
    work1_stateOfStick: null,
    work1_scaleToApron: null,
    work1_stateOfScaleToApron: null,
    work1_width: null,
    work1_length: null,
    work1_height: null,
    work1_overflow: null,
    work1_overflowHeight: null,
    work1_continuousWater: null,
    work1_continuousWaterHeight: null,
    work1_warehouse: null,
    work1_warehouseHight: null,
    work1_presenceWasteWater: null,
    work1_presenceHydrocarbon: null,
    work1_performedDescent: null,
    work1_numberArrival: null,
    work1_observation: null,
    work1_regulationModel: null,
    work1_regulationLocation: null,
    work1_regulationNumber: null,
    work1_regulationDischargeHeight: null,
    work1_regulationOperation: null,
    work1_regulationRope: null,
    work1_regulationDiameter: null,
    work1_regulationSluiceGate: null,
    work1_regulationOverflow: null,
    work1_regulationHeight: null,
    work1_regulationEvacuationEquip: null,
    work1_evacuationMaintenanceRetention: null,
    work1_evacuationMaintenanceControl: null,
    work1_observationRegulation: null,
    work2_accessibilityProblem: null,
    work2_commentAccessibilityProblem: null,
    work2_operationProblem: null,
    work2_commentOperationProblem: null,
    work2_trapdoor: null,
    work2_numberTrapdoor: null,
    work2_stateOfTrapdoor: null,
    work2_stick: null,
    work2_stateOfStick: null,
    work2_scaleToApron: null,
    work2_stateOfScaleToApron: null,
    work2_width: null,
    work2_length: null,
    work2_height: null,
    work2_overflow: null,
    work2_overflowHeight: null,
    work2_continuousWater: null,
    work2_continuousWaterHeight: null,
    work2_warehouse: null,
    work2_warehouseHight: null,
    work2_presenceWasteWater: null,
    work2_presenceHydrocarbon: null,
    work2_performedDescent: null,
    work2_numberArrival: null,
    work2_observation: null,
    work2_regulationModel: null,
    work2_regulationLocation: null,
    work2_regulationNumber: null,
    work2_regulationDischargeHeight: null,
    work2_regulationOperation: null,
    work2_regulationRope: null,
    work2_regulationDiameter: null,
    work2_regulationSluiceGate: null,
    work2_regulationOverflow: null,
    work2_regulationHeight: null,
    work2_regulationEvacuationEquip: null,
    work2_evacuationMaintenanceRetention: null,
    work2_evacuationMaintenanceControl: null,
    work2_observationRegulation: null,
    work3_accessibilityProblem: null,
    work3_commentAccessibilityProblem: null,
    work3_operationProblem: null,
    work3_commentOperationProblem: null,
    work3_trapdoor: null,
    work3_numberTrapdoor: null,
    work3_stateOfTrapdoor: null,
    work3_stick: null,
    work3_stateOfStick: null,
    work3_scaleToApron: null,
    work3_stateOfScaleToApron: null,
    work3_width: null,
    work3_length: null,
    work3_height: null,
    work3_overflow: null,
    work3_overflowHeight: null,
    work3_continuousWater: null,
    work3_continuousWaterHeight: null,
    work3_warehouse: null,
    work3_warehouseHight: null,
    work3_presenceWasteWater: null,
    work3_presenceHydrocarbon: null,
    work3_performedDescent: null,
    work3_numberArrival: null,
    work3_observation: null,
    work3_regulationModel: null,
    work3_regulationLocation: null,
    work3_regulationNumber: null,
    work3_regulationDischargeHeight: null,
    work3_regulationOperation: null,
    work3_regulationRope: null,
    work3_regulationDiameter: null,
    work3_regulationSluiceGate: null,
    work3_regulationOverflow: null,
    work3_regulationHeight: null,
    work3_regulationEvacuationEquip: null,
    work3_evacuationMaintenanceRetention: null,
    work3_evacuationMaintenanceControl: null,
    work3_observationRegulation: null,
    work4_accessibilityProblem: null,
    work4_commentAccessibilityProblem: null,
    work4_operationProblem: null,
    work4_commentOperationProblem: null,
    work4_trapdoor: null,
    work4_numberTrapdoor: null,
    work4_stateOfTrapdoor: null,
    work4_stick: null,
    work4_stateOfStick: null,
    work4_scaleToApron: null,
    work4_stateOfScaleToApron: null,
    work4_width: null,
    work4_length: null,
    work4_height: null,
    work4_overflow: null,
    work4_overflowHeight: null,
    work4_continuousWater: null,
    work4_continuousWaterHeight: null,
    work4_warehouse: null,
    work4_warehouseHight: null,
    work4_presenceWasteWater: null,
    work4_presenceHydrocarbon: null,
    work4_performedDescent: null,
    work4_numberArrival: null,
    work4_observation: null,
    work4_regulationModel: null,
    work4_regulationLocation: null,
    work4_regulationNumber: null,
    work4_regulationDischargeHeight: null,
    work4_regulationOperation: null,
    work4_regulationRope: null,
    work4_regulationDiameter: null,
    work4_regulationSluiceGate: null,
    work4_regulationOverflow: null,
    work4_regulationHeight: null,
    work4_regulationEvacuationEquip: null,
    work4_evacuationMaintenanceRetention: null,
    work4_evacuationMaintenanceControl: null,
    work4_observationRegulation: null,
    work5_accessibilityProblem: null,
    work5_commentAccessibilityProblem: null,
    work5_operationProblem: null,
    work5_commentOperationProblem: null,
    work5_trapdoor: null,
    work5_numberTrapdoor: null,
    work5_stateOfTrapdoor: null,
    work5_stick: null,
    work5_stateOfStick: null,
    work5_scaleToApron: null,
    work5_stateOfScaleToApron: null,
    work5_width: null,
    work5_length: null,
    work5_height: null,
    work5_overflow: null,
    work5_overflowHeight: null,
    work5_continuousWater: null,
    work5_continuousWaterHeight: null,
    work5_warehouse: null,
    work5_warehouseHight: null,
    work5_presenceWasteWater: null,
    work5_presenceHydrocarbon: null,
    work5_performedDescent: null,
    work5_numberArrival: null,
    work5_observation: null,
    work5_regulationModel: null,
    work5_regulationLocation: null,
    work5_regulationNumber: null,
    work5_regulationDischargeHeight: null,
    work5_regulationOperation: null,
    work5_regulationRope: null,
    work5_regulationDiameter: null,
    work5_regulationSluiceGate: null,
    work5_regulationOverflow: null,
    work5_regulationHeight: null,
    work5_regulationEvacuationEquip: null,
    work5_evacuationMaintenanceRetention: null,
    work5_evacuationMaintenanceControl: null,
    work5_observationRegulation: null,
    result: null,
};
